import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "This example demonstrates the main mechanisms of sound source localization in the horizontal plane. You can drag the sound source along the dashed path and see how the ITD and broadband ILD values change with the angle of incidence.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0212/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
